import React from 'react';

import useAssetRepositoryUpload, {
  UploadResult,
} from 'modules/shared-menu/hooks/useAssetRepositoryUpload/useAssetRepositoryUpload';

import { DroppableFileInput } from './DroppableFileInput';

type Props = {
  onUploadFinished?: (result: UploadResult) => void;
};

export const ImagesUploader = ({ onUploadFinished }: Props) => {
  const { uploadAssets, isLoading, progress } = useAssetRepositoryUpload();

  const handleFileDrop = async ({ acceptedFiles }: { acceptedFiles: File[] }) => {
    const uploadResult = await uploadAssets(acceptedFiles);
    onUploadFinished?.(uploadResult);
  };

  return <DroppableFileInput onDrop={handleFileDrop} isLoading={isLoading} progress={progress} />;
};
